'use client';

import { GlobeLines, Help, Mail, Padlock } from '@doist/icons/brand';
import { Box, Button, Heading, MetaPill } from '@doist/marketist';
import { useTranslation } from 'app/i18n/client';
import { useLocale } from 'next-intl';
import css from './side-info.module.css';
import type { Integration } from 'app/[locale]/integrations/types';
function SideInfo({
  integration
}: {
  integration: Integration;
}) {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'integrations');
  const {
    helpCenterUrl
  } = integration.fields;
  const {
    appWebsiteLink,
    privacyPolicyLink,
    supportLink,
    supportedLanguages,
    categories = []
  } = integration.fields.commonContent?.fields || {};
  const moreLinks = [{
    text: t('asideInfo.developer'),
    href: appWebsiteLink,
    Icon: GlobeLines
  }, {
    text: t('asideInfo.support'),
    href: supportLink,
    Icon: Mail
  }, {
    text: t('asideInfo.help'),
    href: helpCenterUrl,
    Icon: Help
  }, {
    text: t('asideInfo.privacy'),
    href: privacyPolicyLink,
    Icon: Padlock
  }].filter(link => link.href && typeof link.href === 'string');
  return <Box tag="aside" className={css.asideInfo} data-sentry-element="Box" data-sentry-component="SideInfo" data-sentry-source-file="side-info.tsx">
            {categories.length > 0 && <Box tag="section">
                    <Heading level="3" className="mbe-12" size="minor-base" weight="semibold">
                        {t('asideInfo.category')}
                    </Heading>
                    <Box tag="ul" className={css.list}>
                        {categories.map(c => <MetaPill key={c?.fields.slug} size="small" href={`/integrations/category/${c?.fields.slug}`}>
                                {c?.fields.name}
                            </MetaPill>)}
                    </Box>
                </Box>}
            {supportedLanguages && <Box tag="section">
                    <Heading level="3" className="mbe-12" size="minor-base" weight="semibold">
                        {t('asideInfo.languages')}
                    </Heading>
                    <Box tag="ul" className={css.list}>
                        {supportedLanguages.map(lang => <MetaPill key={lang} size="small">
                                {t(`contentfulLangs.${lang}`)}
                            </MetaPill>)}
                    </Box>
                </Box>}
            <Box tag="section" data-sentry-element="Box" data-sentry-source-file="side-info.tsx">
                <Heading level="3" className="mbe-12" size="minor-base" weight="semibold" data-sentry-element="Heading" data-sentry-source-file="side-info.tsx">
                    {t('asideInfo.more')}
                </Heading>

                <Box tag="ul" className={css.links} data-sentry-element="Box" data-sentry-source-file="side-info.tsx">
                    {moreLinks.map(link => <Button key={`more-${link.text}`} href={link.href} startIcon={link.Icon} variant="tertiary" bleed="inline" size="small">
                            {link.text}
                        </Button>)}
                </Box>
            </Box>
        </Box>;
}
export { SideInfo };